export type CvExportFormat = 'pdf' | 'docx' | 'txt' | 'md';

export function isPaidCvExportFormat(format: CvExportFormat | string) {
  return format === 'docx' || format === 'txt' || format === 'md';
}
